import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { collectionGroup, getDocs } from "firebase/firestore";
import { db } from "config/firebase";
import { UserInfo } from "@freetech/models/user";

// TODO: Refactor this to be an api call
export const usePublicUserList = (): UseQueryResult<UserInfo[]> => {
  return useQuery({
    queryKey: ["users", "public-info"],
    staleTime: 1000 * 60 * 5, // 5 minutes
    queryFn: async () => {
      try {
        const profilesRef = collectionGroup(db, "profile");
        const snapshot = await getDocs(profilesRef);

        const users = snapshot.docs
          .map((doc) => {
            const data = doc.data();
            if (doc.id !== "public") return null;

            const parentId = doc.ref.parent.parent?.id;
            if (!parentId) return null;

            return {
              id: parentId,
              email: data.email,
              firstName: data.firstName,
              lastName: data.lastName,
              displayName: data.displayName,
              profilePicture: data.profilePicture,
            } as UserInfo;
          })
          .filter((user): user is UserInfo => user !== null);

        return users;
      } catch (error) {
        console.error("Error fetching public profiles:", error);
        throw error;
      }
    },
  });
};
